<div class="dialog-complex">
  <div class="scrollable-zone">
    <div class="header">
      <div class="close-button">
        <app-dialog-close-button (buttonClick)="close.emit()"></app-dialog-close-button>
      </div>

      <h1
        cdkFocusInitial
        class="title"
        *ngIf="textContent.title"
        [id]="textContent.titleId ? textContent.titleId : 'titre-modale'"
      >
        {{ textContent.title | translate }}
      </h1>
    </div>
    <ng-content select="div.dialog-complex-content"></ng-content>
  </div>

  <div class="buttons">
    <button
      *ngIf="textContent.cancelButton"
      mat-button
      [id]="textContent.cancelButtonId ? textContent.cancelButtonId : 'btn-annuler'"
      (click)="close.emit()"
      class="white"
    >
      {{ textContent.cancelButton | translate }}
    </button>
    <button
      *ngIf="textContent.confirmButton"
      mat-button
      [id]="textContent.confirmButtonId ? textContent.confirmButtonId : 'btn-confirmer'"
      (click)="confirm.emit()"
      class="green"
    >
      {{ textContent.confirmButton | translate }}
    </button>
  </div>
</div>
